module.exports = __webpack_public_path__ + "static/media/service.dbdb725a.svg";